import { Injectable } from '@angular/core'
import { Headers, Http, RequestOptions, Response } from '@angular/http'
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/operator/toPromise'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/catch'
import 'rxjs/add/observable/throw'

import { TransformacionService } from './transformacion.service'
import { PreguntaPrimerNivel } from '../dominio/pregunta-primer-nivel'
import { PreguntaSecundaria } from '../dominio/pregunta-secundaria'
import { RespuestaPrimerNivel } from '../dominio/respuesta-primer-nivel'
import { RespuestaSecundaria } from 'app/dominio/respuesta-secundaria'
import { environment } from 'environments/environment'
import { Declaracion } from '../dominio/declaracion'

@Injectable()
export class PreguntaService {

  private urlBase: string = environment.host
  private urlRespuestasPrimerNivel = `${this.urlBase}/respuestas/primer-nivel`
  private urlRespuestasSecundarias = '/respuestas/secundarias/'
  private pathSiguiente = '/siguiente'

  constructor (private http: Http, private transformacion: TransformacionService) {}

  obtenerPreguntaSecundariaDeRespuestaPrimerNivel(id: String, declaracion: Declaracion): Observable<PreguntaSecundaria> {
    const headers = new Headers({ 'Content-Type': 'application/json' })
    const options = new RequestOptions({ headers: headers, withCredentials: true})
    return this.http
      .post(`${this.urlRespuestasPrimerNivel}${this.pathSiguiente}`, { id: id, declaracion: declaracion.toJson() }, options)
      .map(res => this.procesarRespuesta(res, id))
      .catch(this.manejarError)
  }

  obtenerPreguntaSecundariaSiguiente(id: String): Observable<any> {
    return this.http
      .get(`${this.urlBase}${this.urlRespuestasSecundarias}${id}${this.pathSiguiente}`, { withCredentials: true })
      .map((res) => {
        const resultado = res.json()
        switch (resultado.data.type) {
          case 'pregunta' :
            return this.procesarRespuesta(res, id)
          case 'conclusion' :
            return { tipo: 'Conclusion' }
        }
      })
      .catch(this.manejarError)
  }

  construirPreguntaSecundariaD(ps) {
    return {
      id: ps.id,
      idRespuesta: ps.respuestaSeleccionada
    }
  }

  private transformarRespuesta(res: Response): PreguntaPrimerNivel[] {
    const body = res.json()
    return this.transformacion.transformarJsonapiAPreguntasPrimerNivel(body)
  }

  private procesarRespuesta(res, id): any {
    const cuerpo = res.json().data
    if (cuerpo.type === 'conclusion') {
      dispatchEvent(new CustomEvent('cerrarRespuesta', {detail: {idRespuesta: id, sinCollage: true}}))
      return null
    }
    return this.transformacion.transformarPreguntaSecundaria(cuerpo)
  }

  private manejarError (error: Response | any) {
    let errMsg: string
    if (error instanceof Response) {
      const body = error.json() || ''
      const err = body.error || JSON.stringify(body)
      errMsg = body[0].mensaje
    } else {
      errMsg = error.message ? error.message : error.toString()
    }
    return Observable.throw(errMsg)
  }
}



// WEBPACK FOOTER //
// ./src/app/servicios/preguntas.service.ts